/**
 * StatusPill — shared visual primitive for status badges across modules.
 *
 * Each module (orders, measurement, future delivery / WO / PO) keeps its
 * own STATUS_STYLES map because the lifecycle vocabularies are distinct and
 * shouldn't merge. This primitive only owns the layout + sizing, so a token
 * change (e.g. border radius, padding) lands in one place.
 */

export interface StatusPillProps {
  label: string;
  /** Tailwind classes for background, text, border, font-weight. */
  className: string;
}

export default function StatusPill({ label, className }: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 text-xs font-medium tracking-wide uppercase border ${className}`}
    >
      {label}
    </span>
  );
}
